import React from 'react';
import { useSelector } from 'react-redux';

import { Altitude as AltitudeUI } from '@/components/ui/dashboard/Monitor';

const Altitude = ({ data: robotId }) => {
  const droneOsd = useSelector((state) => state.telemetry[robotId]?.droneOsd);

  return <AltitudeUI relAltitude={droneOsd?.elevation ?? 0} />;
};

export default Altitude;
